// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html .cog-input .el-textarea,:root:root:root:root:root .cog-input .el-textarea{display:flex}html .cog-input .el-textarea__inner,:root:root:root:root:root .cog-input .el-textarea__inner{overflow:auto;resize:vertical}", ""]);
// Exports
module.exports = exports;
